import { useTranslation } from 'react-i18next'

const Kitchen2 = (props) => { 
  const { t } = useTranslation()
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="kitchen2-title"
      {...props}
    >
      <title id="kitchen2-title">{t('antagonists:mum:components:background')}</title>
      <defs>
        <clipPath id="kitchen2-a">
          <path
            style={{
              fill: 'none',
            }}
            d="M0 0h1920v1080H0z"
          />
        </clipPath>
        <clipPath id="kitchen2-b">
          <path
            style={{
              fill: '#dbdbde',
            }}
            d="m889.92 889.37-.48-293.32-355.08-2.04 5.16 293.47 350.4 1.89z"
          />
        </clipPath>
        <clipPath id="kitchen2-c">
          <path
            d="m1797.28 543.28.67 4.75-8.83 2.89s-24.28 28.75-70.2 25.66c-45.91-3.09-59.91-39.99-59.91-39.99l2.43-2.12a3.804 3.804 0 0 1 4.86-.12c5.61 4.43 20.9 14.84 44.35 18.26 30.09 4.38 62.45-11.85 67.49-11.45 5.04.39 11.4 1.4 11.4 1.4l7.73.73Z"
            style={{
              fill: '#fab700',
            }}
          />
        </clipPath>
        <clipPath id="kitchen2-d">
          <path
            d="m1804.38 557.47-1.06 4.67-9.28-.43s-32.91 18.24-74.73-.97c-41.82-19.21-41.78-58.68-41.78-58.68l3.03-1.12c1.72-.63 3.65.04 4.59 1.61 3.67 6.13 14.26 21.3 34.96 32.83 26.57 14.79 62.58 11.13 67.16 13.29 4.57 2.16 10.16 5.36 10.16 5.36l6.96 3.43Z"
            style={{
              fill: '#fab700',
            }}
          />
        </clipPath>
      </defs>
      <g
        style={{
          clipPath: 'url(kitchen2-#a)',
        }}
      >
        <path
          style={{
            fill: '#f1f1f3',
          }}
          d="M-176.59-177.55h2325.36V954H-176.59z"
        />
        <path
          id="ENVIRONMENT_BACKGROUND"
          style={{
            fill: '#ecd583',
          }}
          d="M-295.8 810.11h2433.77v676.64H-295.8z"
        />
        <path
          style={{
            fill: '#e2e6ea',
          }}
          d="M-747.82-50.39H900.01v642.75H-747.82z"
        />
        <path
          style={{
            fill: '#f8f7f0',
          }}
          d="m61.32 497.8.54 41.91-83.18.27 1.35-41.91 81.29-.27zm.45-45.64.54 40.98-81.29-.19.39-40.51 80.36-.28zm8.89 45.66-1.35 41.91 83.18.66-.54-41.91-81.29-.66zm.45-45.63-1.35 40.97 81.3.2.39-40.52-80.34-.65zm171.48 46.04.54 41.91-83.19.27 1.35-41.91 81.3-.27zm.44-45.64.55 40.98-81.29-.19.39-40.51 80.35-.28zm8.9 45.66-1.35 41.91 83.18.66-.54-41.91-81.29-.66zm.44-45.64-1.34 40.98 81.29.2.39-40.52-80.34-.66zm171.48 46.05.54 41.91-83.19.27 1.36-41.91 81.29-.27zm.45-45.64.54 40.98-81.29-.19.39-40.51 80.36-.28zm8.89 45.66-1.35 41.91 83.18.66-.54-41.91-81.29-.66zm.45-45.64-1.35 40.98 81.3.2.39-40.52-80.34-.66zm171.48 46.05.54 41.91-83.19.27 1.35-41.91 81.3-.27zm.44-45.64.55 40.98-81.29-.19.39-40.51 80.35-.28zM63.53 405.79l.54 41.92-83.19.26 1.35-41.9 81.3-.28zm9.34.02-1.36 41.91 83.18.67-.54-41.92-81.28-.66zm171.92.41.54 41.92-83.19.26 1.35-41.9 81.3-.28zm9.34.02-1.35 41.91 83.18.67-.54-41.92-81.29-.66zm171.93.41.54 41.92-83.19.26 1.35-41.9 81.3-.28zm9.34.02-1.36 41.91 83.18.67-.54-41.92-81.28-.66zm171.92.41.54 41.92-83.19.26 1.35-41.9 81.3-.28zm91.89 91.15.54 41.91-83.19.27 1.35-41.91 81.3-.27zm.44-45.64.55 40.98-81.29-.19.39-40.51 80.35-.28zm8.9 45.66-1.35 41.91 83.18.66-.54-41.91-81.29-.66zm.44-45.63-1.34 40.97 81.29.2.4-40.52-80.35-.65zm171.49 46.04.53 41.91-83.18.27 1.35-41.91 81.3-.27zm.44-45.64.55 40.98-81.3-.19.4-40.51 80.35-.28zm-179.51-46.8.54 41.92-83.19.26 1.36-41.9 81.29-.28zm9.34.02-1.35 41.91 83.18.67-.54-41.92-81.29-.66zm171.93.41.54 41.92-83.19.26 1.35-41.9 81.3-.28z"
        />
        <path
          style={{
            fill: '#a8c4cc',
          }}
          d="m909.93 930.02-.79-367.34-1192.78.51-.01-3.93-280.47-1.08-1.46 371.25 1475.51.59z"
        />
        <path
          style={{
            fill: '#dbdbde',
          }}
          d="m889.92 889.37-.48-293.32-355.08-2.04 5.16 293.47 350.4 1.89z"
        />
        <g
          style={{
            clipPath: 'url(kitchen2-#b)',
          }}
        >
          <path
            style={{
              fill: '#fbf8f6',
            }}
            d="M461.07 665.87h469.02l-11.73-126.05-427.97 17.59-29.32 108.46z"
          />
          <path
            style={{
              fill: '#dedee1',
            }}
            d="M461.07 658.5h469.02l-11.73-126.05-427.97 17.59-29.32 108.46z"
          />
        </g>
        <path
          style={{
            fill: '#f0f4f8',
          }}
          d="m512.11 889.28 1.55-294.33-174 1.24-2.07 291.2 174.52 1.89zM154.2 596.45l.42 291.93 178.08.99-1.13-292.6-177.37-.32z"
        />
        <path
          style={{
            fill: '#a8914b',
          }}
          d="m317.5 681.34 5.46-.03-.25-62.58-5.44.03.23 62.58zm33.15-.87 5.46-.04-.25-62.58-5.44.04.23 62.58z"
        />
        <path
          style={{
            fill: '#f0f4f8',
          }}
          d="m138.41 889.37-.48-293.32-174 1.24-.05 290.19 174.53 1.89z"
        />
        <path
          d="m75.38 561.31-.29-34.54 13.93-.29.29 11.03 16.25-.58s2.03 2.03 1.74 6.68c-.29 4.64-1.45 8.13-1.45 8.13l-16.54.29.29 9.87-14.22-.58Z"
          style={{
            fill: '#aea7ab',
          }}
        />
        <path
          style={{
            fill: '#aea7ab',
          }}
          d="m100.05 540.6 1.9-18.77 2.68.32-1.27 18.6-3.31-.15zm-21.44-12.62s-1.42-71.12-1.58-77.75c-.16-6.62 1.12-9.81 2.84-13.25 1.89-3.78 3.47-6.47 7.88-8.36 4.42-1.89 17.24-6.04 20.82-6.78 3.78-.79 8.97.09 11.99 6.62 2.84 6.15 3.15 17.5 3.15 17.5l-8.04.47s-.29-6.26-.47-8.2c-.47-5.05-2.21-9.46-4.42-9.3-3.19.23-18.27 5.58-20.19 6.31-3.31 1.26-4.73 5.52-5.52 9.78-1.01 5.45.79 84.05.79 84.05l-7.25-1.1Z"
        />
        <path
          d="m1797.28 543.28.67 4.75-8.83 2.89s-24.28 28.75-70.2 25.66c-45.91-3.09-59.91-39.99-59.91-39.99l2.43-2.12a3.804 3.804 0 0 1 4.86-.12c5.61 4.43 20.9 14.84 44.35 18.26 30.09 4.38 62.45-11.85 67.49-11.45 5.04.39 11.4 1.4 11.4 1.4l7.73.73Z"
          style={{
            fill: '#fab700',
          }}
        />
        <g
          style={{
            clipPath: 'url(kitchen2-#c)',
          }}
        >
          <path
            style={{
              fill: '#835944',
            }}
            d="m1789.3 536.38 1.14 21.57 21.24-8.25-3.19-22.1-19.19 8.78z"
          />
        </g>
        <path
          d="M1755.18 558.19s-20.42 6.46-50.73-.4c-27.64-6.25-36.61-15.85-36.61-15.85l-.61 1.34s7.92 10.4 37.01 17.38c29.28 7.03 51.64-.97 51.64-.97l-.7-1.5Z"
          style={{
            fill: '#a67238',
          }}
        />
        <path
          d="M1773.73 553.25s-9.02 8.08-34.62 12.14c-23.2 3.67-38.67-.55-38.67-.55l-.56 1.44s15.02 5.71 39.95 1.61c25.12-4.13 34.95-13.57 34.95-13.57l-1.05-1.06Z"
          style={{
            fill: '#835944',
          }}
        />
        <path
          d="m1804.38 557.47-1.06 4.67-9.28-.43s-32.91 18.24-74.73-.97c-41.82-19.21-41.78-58.68-41.78-58.68l3.03-1.12c1.72-.63 3.65.04 4.59 1.61 3.67 6.13 14.26 21.3 34.96 32.83 26.57 14.79 62.58 11.13 67.16 13.29 4.57 2.16 10.16 5.36 10.16 5.36l6.96 3.43Z"
          style={{
            fill: '#fab700',
          }}
        />
        <g
          style={{
            clipPath: 'url(kitchen2-#d)',
          }}
        >
          <path
            style={{
              fill: '#835944',
            }}
            d="m1799.38 548.18-6.6 20.58 22.78-.16 4.88-21.8-21.06 1.38z"
          />
        </g>
        <path
          d="M1769.65 553.67s-21.33 1.97-49.49-11.17c-25.68-11.99-32.4-23.27-32.4-23.27l-.88 1.18s5.53 11.84 32.47 24.85c27.11 13.09 50.67 10.03 50.67 10.03l-.36-1.61Z"
          style={{
            fill: '#835944',
          }}
        />
        <path
          d="M1780.23 556.23s-11.31 4.35-36.67-.96c-22.99-4.81-35.95-14.26-35.95-14.26l-1.03 1.15s12.01 10.68 36.77 15.71c24.95 5.07 37.49-.26 37.49-.26l-.61-1.36Z"
          style={{
            fill: '#a67238',
          }}
        />
        <path
          d="M1650.59 567.78s2.65 14.28 7.2 20.48c6.09 8.3 13.17 17.8 13.17 17.8l115.48-1.19s16.33-13.6 19.35-20.65c3.02-7.05 5.29-16.12 5.29-16.12l-160.49-.32Z"
          style={{
            fill: '#75c6cf',
          }}
        />
        <path
          d="M1555.01 562.36c.31 7.53 3.68 11.68 8.7 11.68 4.68 0 6.35-3.43 7.45-4.31 1.44-1.15 2.79-.92 2.93.87.11 1.34 2.07 26.88 2.07 26.88l42.34.47 2.64-50.74c.05-.88-.52-1.68-1.37-1.92-3.11-.89-41.6-1.41-44.98-.56-1.22.31-2.17.93-2.14 2.19.01.6.14 6.83.18 7.28.15 1.8-.74 1.61-1.06 1.34-.57-.48-2.87-5.8-8.67-5.64-5.8.16-8.4 4.91-8.09 12.44Zm7.96-9.55c3.72-.26 6.7 3.88 6.93 9.14.23 5.27-3.46 9.18-6.17 9.18s-5.57-3.16-5.87-8.73c-.34-6.34 1.71-9.36 5.12-9.59Z"
          style={{
            fill: '#80b76d',
          }}
        />
        <path
          style={{
            fill: '#a8914b',
          }}
          d="m1344.5 631.37 1396.19 2.46-.35-34.78-1395.83-6.17-.01 38.49z"
        />
        <path
          style={{
            fill: '#a8914b',
          }}
          d="m1364.22 933.5 15.69-326.82 33.99 2.62-26.15 324.2h-23.53z"
        />
        <path
          style={{
            fill: '#9398af',
          }}
          d="m672.64 607.76 85.41.54v17.95l-85.95.55.54-19.04z"
        />
        <path
          d="M787.85 623.94c4.29-.38 6.09-3.63 5.77-6.46-.37-3.29-2.54-5.63-6.47-5.52-3.71.1-6.38 3.27-5.54 7.19.7 3.24 3.04 5.06 6.24 4.78Z"
          style={{
            fill: '#ec705c',
          }}
        />
        <path
          d="M810.14 624.26c4.29-.38 6.09-3.63 5.77-6.46-.37-3.29-2.54-5.63-6.47-5.52-3.71.1-6.38 3.27-5.54 7.19.7 3.24 3.04 5.06 6.24 4.78Z"
          style={{
            fill: '#ffd500',
          }}
        />
        <path
          style={{
            fill: '#f8f7f0',
          }}
          d="m606.66 357.05.54 41.91-83.19.27 1.35-41.91 81.3-.27zm.44-45.64.55 40.98-81.29-.19.39-40.52 80.35-.27zm1.76-46.37.54 41.91-83.19.27 1.36-41.91 81.29-.27zm91.89 91.15.54 41.91-83.19.27 1.36-41.91 81.29-.27zm.45-45.64.54 40.98-81.29-.19.39-40.52 80.36-.27zm8.89 45.66-1.35 41.91 83.18.66-.54-41.91-81.29-.66zm.45-45.64-1.35 40.98 81.3.19.39-40.51-80.34-.66zm171.48 46.05.54 41.91-83.19.27 1.35-41.91 81.3-.27zm.44-45.64.55 40.98-81.29-.19.39-40.52 80.35-.27zm-179.5-46.8.54 41.91-83.19.27 1.35-41.91 81.3-.27zm9.34.02-1.36 41.91 83.18.66-.54-41.91-81.28-.66zm171.92.41.54 41.91-83.19.27 1.35-41.91 81.3-.27zM606.66 216.43l.54 41.91-83.19.27 1.35-41.91 81.3-.27zm.44-45.64.55 40.99-81.29-.2.39-40.51 80.35-.28zm1.76-46.37.54 41.92-83.19.27 1.36-41.91 81.29-.28zm91.89 91.15.54 41.91-83.19.27 1.36-41.91 81.29-.27zm.45-45.64.54 40.99-81.29-.2.39-40.51 80.36-.28zm8.89 45.66-1.35 41.91 83.18.66-.54-41.91-81.29-.66zm.45-45.63-1.35 40.97 81.3.2.39-40.52-80.34-.65zM882.02 216l.54 41.91-83.19.27 1.35-41.91 81.3-.27zm.44-45.64.55 40.99-81.29-.2.39-40.51 80.35-.28zm-179.5-46.8.54 41.92-83.19.27 1.35-41.91 81.3-.28zm9.34.03-1.36 41.9 83.18.67-.54-41.92-81.28-.65zm171.92.4.54 41.92-83.19.27 1.35-41.91 81.3-.28zM606.66 75.81l.54 41.92-83.19.27 1.35-41.91 81.3-.28zm.44-45.63.55 40.98-81.29-.19.39-40.52 80.35-.27zm1.76-46.37.54 41.91-83.19.27 1.36-41.91 81.29-.27zm91.89 91.14.54 41.92-83.19.27 1.36-41.91 81.29-.28zm.45-45.63.54 40.98-81.29-.19.39-40.52 80.36-.27zm8.89 45.66-1.35 41.91 83.18.66-.54-41.91-81.29-.66zm.45-45.64-1.35 40.98 81.3.19.39-40.51-80.34-.66zm171.48 46.04.54 41.92-83.19.27 1.35-41.91 81.3-.28zm.44-45.63.55 40.98-81.29-.19.39-40.52 80.35-.27zm-179.5-46.8.54 41.91-83.19.27 1.35-41.91 81.3-.27zm9.34.02-1.36 41.91 83.18.66-.54-41.91-81.28-.66zm171.92.41.54 41.91-83.19.27 1.35-41.91 81.3-.27z"
        />
        <path
          style={{
            fill: '#a8c4cc',
          }}
          d="m-1015.65-54.73.79 444.9 1543.1 2.72-.06-444.57-1543.83-3.05z"
        />
        <path
          style={{
            fill: '#f0f4f8',
          }}
          d="m131.78 372.44-.48-342.72-174.04-.94v341.77l174.52 1.89zM508.08 368.01l-.48-342.72-174.04-.94v341.77l174.52 1.89zM146.18 25.8l2.45 338.29 178.07.99-2.15-342.27-178.37 2.99z"
        />
        <path
          style={{
            fill: '#a8914b',
          }}
          d="m311.39 343.27 5.45-.04-.32-74.6-5.44.03.31 74.61zm31.09-1.02 5.45-.03-.32-74.61-5.44.03.31 74.61z"
        />
        <path
          style={{
            fill: 'none',
            stroke: '#96a2a4',
            strokeMiterlimit: 10,
            strokeWidth: '2.2px',
          }}
          d="M1741.34 297.42V-81.3"
        />
        <path
          d="M1741.05 288.92s-87.36 26.7-93.86 54.89c-5.92 25.66-4.64 39.07-4.64 39.07l193.37-.75s4.41-13.24-6.07-37.51c-12.94-29.97-88.8-55.71-88.8-55.71Z"
          style={{
            fill: '#272a3e',
          }}
        />
        <path
          d="m575.57 568.11-8.3-107.76 80.93 1.62s-12.16 15.86-16.19 38.31c-3.09 17.2-8.27 66.79-8.27 66.79l-48.18 1.05Z"
          style={{
            fill: '#f4a019',
          }}
        />
        <path
          d="m581.52 532.1-22.67-4.69a12.464 12.464 0 0 1-9.95-11.72l-1.39-34.13c-.27-6.55 4.63-12.23 11.15-12.93l19.99-2.14.56 5.2-19.99 2.14c-3.79.41-6.64 3.71-6.49 7.52l1.39 34.13a7.265 7.265 0 0 0 5.79 6.82l22.67 4.69-1.06 5.12Z"
          style={{
            fill: '#f4a019',
          }}
        />
        <path
          d="M696.68 489.24s1.02 4.03 3.6 10.49 7.78 12.97 7.78 12.97l87.09 3.04s5.3-7.14 7.44-12.72c2.14-5.58 3.76-12.78 3.76-12.78l-109.67-1Z"
          style={{
            fill: '#fdd900',
          }}
        />
        <path
          d="M696.95 490.17s-3.51-2.24-9.81-5.18c-6.31-2.94-14.55-4.11-14.55-4.11l-65.51 57.47s1.03 8.83 3.3 14.36c2.27 5.53 6.02 11.89 6.02 11.89l80.56-74.43Z"
          style={{
            fill: '#ee7f00',
          }}
        />
        <path
          d="M693.14 497.11s.71 4.18 2.79 11.06c2.08 6.87 6.76 14.25 6.76 14.25l86.29 18.28s5.8-6.16 8.34-11.33 4.7-12.04 4.7-12.04l-108.88-20.21Z"
          style={{
            fill: '#2a5151',
          }}
        />
        <path
          d="M695.25 521.52s.71 4.09 2.8 10.7c2.08 6.62 6.78 13.45 6.78 13.45l86.68 8.8s5.83-6.77 8.38-12.19c2.56-5.43 4.72-12.49 4.72-12.49l-109.37-8.26Z"
          style={{
            fill: '#00a39a',
          }}
        />
        <path
          d="M695.64 542.87s1.05 4.01 3.67 10.43 7.87 12.84 7.87 12.84l87.11 1.61s5.25-7.22 7.35-12.84c2.1-5.62 3.67-12.84 3.67-12.84l-109.68.8Z"
          style={{
            fill: '#4aa83f',
          }}
        />
        <path
          d="m513.12 498.44 82.04-2.38a2.45 2.45 0 0 1 2.52 2.59l-.32 6.03a1.96 1.96 0 0 1-1.94 1.86l-81.86 1.79-.45-9.89Z"
          style={{
            fill: '#007581',
          }}
        />
        <path
          style={{
            fill: '#007581',
          }}
          d="m442.74 497.91 2.48 65.66 80.02-.09 5.24-66.76-87.74 1.19z"
        />
        <path
          d="M441.19 497.92h89.98l-4.09-7.68c-1.01-1.41-2.76-2.26-4.63-2.25l-71.73.64c-1.88 0-3.63.87-4.63 2.3l-4.9 6.99Z"
          style={{
            fill: '#444851',
          }}
        />
        <path
          d="M486.88 478.66c-3.9-.55-6.13 1.22-6.7 3.74-.6 2.64.25 5.89 3.9 6.78 3.72.9 7.11-1.5 7.33-4.3.21-2.66-.64-5.67-4.54-6.22Z"
          style={{
            fill: '#444851',
          }}
        />
        <path
          d="M626.75 536.47c.28 6.73 3.29 10.43 7.77 10.43 4.18 0 5.67-3.06 6.66-3.85 1.29-1.02 2.49-.82 2.62.78.09 1.2 1.85 24.02 1.85 24.02l37.83.42 2.36-45.34c.04-.79-.47-1.5-1.23-1.72-2.78-.79-37.17-1.26-40.2-.5-1.09.28-1.94.83-1.91 1.96.01.53.12 6.1.16 6.51.13 1.6-.66 1.44-.95 1.2-.51-.43-2.57-5.18-7.75-5.04-5.18.14-7.51 4.39-7.22 11.12Zm7.11-8.53c3.33-.23 5.99 3.47 6.19 8.17.2 4.71-3.09 8.21-5.52 8.21-2.42 0-4.98-2.83-5.25-7.8-.31-5.67 1.53-8.36 4.57-8.57Z"
          style={{
            fill: '#2cb9d3',
          }}
        />
        <path
          d="M250.44 534.95c.28 7.3 3.3 11.33 7.8 11.33 4.2 0 5.69-3.32 6.69-4.18 1.3-1.11 2.5-.89 2.63.85.09 1.3 1.86 26.08 1.86 26.08l37.98.46 2.37-49.22c.04-.86-.47-1.63-1.23-1.86-2.79-.86-37.32-1.37-40.35-.54-1.1.3-1.94.9-1.92 2.12.01.58.12 6.63.16 7.07.13 1.74-.67 1.57-.95 1.3-.51-.46-2.58-5.62-7.78-5.47-5.2.15-7.53 4.76-7.25 12.07Zm7.14-9.26c3.34-.25 6.01 3.76 6.21 8.87.2 5.12-3.11 8.91-5.54 8.91s-5-3.07-5.27-8.47c-.31-6.15 1.53-9.08 4.59-9.3Z"
          style={{
            fill: '#00a79b',
          }}
        />
        <path
          d="M337.11 453.82c-1.17 12.12-10.23 20.29-11.15 43.23-1.17 29.36-1.55 65.07-1.55 65.07l40.85.99s.27-36.85-1.22-64.4c-1.21-22.2-10.47-28.59-12.71-43.66-1.79-12.01-2.62-23.39-2.62-23.39l-9.72.52s-.75 9.88-1.89 21.64Z"
          style={{
            fill: '#c3e3e8',
          }}
        />
        <path
          d="m337.64 439.96.11-7.67a2.456 2.456 0 0 1 2.39-2.42l7.22-.19a2.46 2.46 0 0 1 2.52 2.4l.17 7.74-12.41.14Z"
          style={{
            fill: '#0081c2',
          }}
        />
        <path
          style={{
            fill: '#2e425b',
          }}
          d="m-479.09 580.36 1396.2 4.6-.37-19.06-1395.84-9.29.01 23.75z"
        />
      </g>
    </svg>
  )
}

export default Kitchen2
